export default __webpack_public_path__ + "static/media/warrewarrewa.893085f1.mp3";